import React from 'react';
import './header-component.css';

/**
 * Composant d'en-tête principal qui affiche le titre de l'application sur fond noir.
 * 
 * @param {Object} props - Propriétés du composant
 * @param {string} props.title - Le titre principal à afficher
 * @param {function} [props.onBack] - Fonction de retour en arrière
 * @param {function} [props.onReset] - Fonction de réinitialisation
 * @param {boolean} [props.showBackButton] - Indique si le bouton de retour doit être affiché
 * @param {boolean} [props.showResetButton] - Indique si le bouton de réinitialisation doit être affiché
 * @param {string} [props.className] - Classes CSS additionnelles
 */
const HeaderComponent = ({ 
  title, 
  onBack, 
  onReset, 
  showBackButton = false,
  showResetButton = false,
  className = '' 
}) => {
  return (
    <div className={`app-header ${className}`}>
      {showBackButton && (
        <button 
          className="app-header-back-button" 
          onClick={onBack}
          aria-label="Retour"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
      )}
      
      <h1 className="app-header-title">{title}</h1>
      
      {showResetButton && (
        <button 
          className="app-header-reset-button" 
          onClick={onReset}
          aria-label="Réinitialiser"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
            <path d="M3 3v5h5"></path>
          </svg>
        </button>
      )}
    </div>
  );
};

export default HeaderComponent;